export function parseEuroAmount(value) {
    return Number(value.replace(/\./g, "").replace(/,/g, "."));
}

export function formatEuroAmount(value) {

    if (value === undefined) {
        return value;
    }

    return new Intl.NumberFormat("de-DE", {
        style: "decimal",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(value);
}

export function formatMileage(value) {

    if (value === undefined) {
        return value;
    }

    return new Intl.NumberFormat("de-DE", {
        style: "decimal",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    }).format(value);
}


export function normalizeEuroAmount(value) {

    if (!value) {
        return value;
    }

    try {
        const parsedValue = parseEuroAmount(value);
        return !Number.isNaN(parsedValue)
            ? formatEuroAmount(parsedValue)
            : value;
    } catch (e) {
        return "";
    }
}
